import { commitMutation } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';
import { getEnvironment } from '../../../../shared/utils/helpers';

const BatchArchiveReviewAssetsMutation = input =>
  new Promise((resolve, reject) => {
    commitMutation(getEnvironment(), {
      mutation: graphql`
        mutation BatchArchiveReviewAssetsMutation($input: ArchiveBatchReviewAssetsInput!) {
          archiveBatchReviewAssets(input: $input) {
            isArchived
            organization {
              storage {
                activeStorageReviewAssets
                archivedStorageReviewAssets
              }
            }
          }
        }
      `,
      variables: {
        input
      },
      onCompleted: resolve,
      onError: reject
    });
  });

export default BatchArchiveReviewAssetsMutation;
